<template>
    <nav class="navbar navbar-top navbar-expand navbar-dashboard navbar-dark pl-0 pr-2 pb-0">
        <div class="container-fluid px-0">
            <div class="d-flex justify-content-between w-100" id="navbarSupportedContent">
                <div class="d-flex">
                </div>
                <!-- Navbar links -->
                <ul class="navbar-nav align-items-center">
                    <li class="nav-item dropdown">
                        <a class="nav-link pt-1 px-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div class="media d-flex align-items-center">
                                <img class="user-avatar md-avatar rounded-circle" alt="Image placeholder" :src="$root.URL_ROOT+'uploads/Slider/'+adminData.avatar">
                                <div class="media-body ml-2 text-dark align-items-center d-none d-lg-block">
                                    <span class="mb-0 font-small font-weight-bold"> {{adminData.username}} </span>
                                </div>
                            </div>
                        </a>
                        <div class="dropdown-menu dashboard-dropdown dropdown-menu-right mt-2">
                             <router-link :to="{name: 'index', params: { page: 'Admin' }}" class="dropdown-item font-weight-bold">
                    <span class="sidebar-icon"><span class="fa fa-user"></span></span>
                    <span>My Profile</span>
                </router-link>
                            <a @click="logout" class="dropdown-item font-weight-bold" href="#">
                                <span class="fa fa-sign-out text-danger"></span>Logout</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
                username: '',
                password: '',
                reminder: true,
                adminData: [],
        }
    },
    mounted(){
        this.getDetail()
    },
    methods: {
         getDetail() {
            var ev = this
            var param = {
                type: 'getAdminDetail'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
               //console.log(response.data)
                var data = response.data;
                ev.adminData = data.data
            })
        },
      logout() {
            localStorage.removeItem("admin");
            localStorage.removeItem("token");
            localStorage.removeItem("latitude");
            localStorage.removeItem("longitude");
            this.$router.push({ name: 'loginuser' })
            this.$router.go("/");
            localStorage.removeItem("isAdmin");
          },
    },
}
</script>
